var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadAreaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 149,
    viewBox: "0 0 255 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__3rd-sheet",
    d: "M159.236 19.2503L125.822 0.890791C122.582 -0.889664 118.522 0.314492 116.755 3.58035L87.6184 57.417C85.851 60.6829 87.045 64.7737 90.2854 66.5542L123.699 84.9136C126.94 86.6941 130.999 85.4899 132.767 82.2241L161.903 28.3874C163.671 25.1216 162.477 21.0307 159.236 19.2503Z",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__2nd-sheet",
    d: "M106.538 11.1956L70.8272 24.4657C67.364 25.7527 65.5947 29.624 66.8753 33.1127L87.9851 90.6221C89.2657 94.1107 93.1112 95.8956 96.5743 94.6087L132.285 81.3385C135.748 80.0516 137.517 76.1803 136.237 72.6916L115.127 15.1822C113.846 11.6935 110.001 9.90867 106.538 11.1956Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__1st-sheet",
    d: "M49.4168 28.3984L22.6934 36.3623C20.1019 37.1347 18.6242 39.8772 19.393 42.488L32.0661 85.5259C32.8349 88.1367 35.559 89.6271 38.1506 88.8548L64.8739 80.8909C67.4655 80.1186 68.9432 77.376 68.1744 74.7652L55.5012 31.7273C54.7324 29.1165 52.0083 27.6261 49.4168 28.3984Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__table-sheet-bg",
    d: "M4.06255 48.8957L31.4821 35.9751L43.0309 40.5552L60.4951 78.1356C60.6843 78.5427 60.792 78.9834 60.8119 79.4324C60.8318 79.8814 60.7635 80.3299 60.6111 80.7522C60.4586 81.1745 60.2249 81.5623 59.9234 81.8934C59.6219 82.2244 59.2585 82.4923 58.8539 82.6815L26.7942 97.7887C25.9797 98.1725 25.0471 98.2145 24.2014 97.9055C23.3558 97.5965 22.6664 96.9618 22.285 96.141L2.43823 53.4337C2.05747 52.6144 2.01464 51.6766 2.31913 50.8259C2.62362 49.9752 3.25058 49.2811 4.06255 48.8957Z",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__table-sheet-sheet",
    d: "M49.1493 67.0652L21.7044 79.9978L11.6685 58.4019L19.599 54.6648L39.1133 45.4693L49.1493 67.0652Z",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__table-sheet-sheet",
    d: "M30.7406 75.74L20.7046 54.144",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__table-sheet-sheet",
    d: "M40.1468 71.3069L30.1108 49.7109",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__table-sheet-sheet",
    d: "M15.2944 66.2031L42.7393 53.2706",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__table-sheet-sheet",
    d: "M18.5317 73.1704L45.9766 60.2379",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4824 35.9751L33.9717 41.3316C34.3531 42.1524 35.0425 42.7871 35.8881 43.0961C36.7338 43.4051 37.6664 43.3631 38.4809 42.9793L43.138 40.7848L31.4824 35.9751Z",
    fill: "#605CFF",
    fillOpacity: 0.4,
    stroke: "#605CFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.546 52.9736L238.363 90.7042C237.967 91.6874 237.2 92.4721 236.231 92.8858C235.261 93.2996 234.168 93.3084 233.193 92.9103L194.686 77.1985C193.711 76.8004 192.932 76.0281 192.522 75.0514C192.112 74.0747 192.104 72.9736 192.5 71.9905L213.279 20.3512C213.457 19.9105 213.719 19.5093 214.05 19.1706C214.381 18.8319 214.776 18.5624 215.211 18.3774C215.645 18.1924 216.112 18.0957 216.584 18.0927C217.056 18.0896 217.524 18.1804 217.961 18.3599L244.019 28.9925"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__plus-sheet-border",
    d: "M253.546 52.9736L238.363 90.7042C237.967 91.6873 237.2 92.4721 236.231 92.8858C235.261 93.2996 234.168 93.3084 233.193 92.9103L194.686 77.1985C193.711 76.8004 192.932 76.0281 192.522 75.0514C192.112 74.0747 192.104 72.9736 192.5 71.9905L213.279 20.3512C213.457 19.9105 213.719 19.5093 214.05 19.1706C214.381 18.8319 214.776 18.5624 215.211 18.3774C215.645 18.1924 216.112 18.0957 216.584 18.0927C217.056 18.0896 217.524 18.1804 217.961 18.3599L244.019 28.9925",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__plus-sheet-corner",
    d: "M244.304 29.3505L239.401 41.5366C238.835 42.9431 238.29 44.096 238.875 45.4927C239.46 46.8893 240.782 47.7656 242.175 48.3342L253.627 53.0067L244.304 29.3505Z",
    fillOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__plus-sheet-plus",
    d: "M227.862 50.2627L221.218 66.7739",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__plus-sheet-plus",
    d: "M216.226 55.1299L232.72 61.8601",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__cloud",
    d: "M0.99996 116.015C0.99996 132.351 13.5522 145.706 29.496 146.902V146.98H203.824C223.803 146.98 240 130.684 240 110.583C240 91.6192 225.596 76.0287 207.196 74.3421C206.163 41.3961 179.285 15 146.287 15C120.013 15 97.6174 31.728 89.0608 55.1628C84.188 52.6919 78.711 51.3191 72.8832 51.3191C53.6455 51.3191 37.9161 66.3998 36.7662 85.4614C35.1484 85.1869 33.4721 85.0496 31.7569 85.0496C14.7607 85.0496 0.980469 98.9144 0.980469 116.015H0.99996Z",
    fill: "#605CFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "upload-modal-area-bg__arrow",
    d: "M90.3765 111.613H151.228L120.802 75.6665L90.3765 111.613Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "upload-modal-area-bg__arrow",
    x: 107.59,
    y: 110.089,
    width: 25.1579,
    height: 38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAreaBg);
export default __webpack_public_path__ + "static/media/uploadAreaBg.9761f0a0e53e4d28e1914e2cf7023eca.svg";
export { ForwardRef as ReactComponent };